import React from "react";
import { places } from "../data/places";
import '../css/global.css';
import '../css/WorkPlaces.css';

const WorkPlaces: React.FC = () => {
    return(
        <section className="work">
            <div className="container">
                <div className="header-content">
                    <span className="sub-heading">Professional Experience</span>
                    <h3>Where I've Worked</h3>
                    <div className="section-divider">
                        <svg
                            width="80"
                            height="16"
                            viewBox="0 0 80 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M2 8 C8 2, 14 2, 20 8
                                S32 14, 38 8
                                S50 2, 56 8
                                S68 14, 78 8"
                                stroke="#B8E986"
                                strokeWidth="4"
                                strokeLinecap="round"
                                fill="none"
                            />
                        </svg>
                    </div>
                </div>
            <div className="row justify-content-center">
            {places.map((place) => (
            <div className="place-col col-sm-3"  key={place.id}>
             
               <div className="places__card">
                 <div className="place__block">
                    <div className="place-image">
                        <span>{place.initials}</span>
                        {/* <img src={place.image}
                            className="img-fluid place__image"
                            alt={place.title} 
                        /> */}
                    </div>
                    <div className="place-headers">
                        <h3 className="place-title">{place.title}</h3>
                        <div className="place__description-block">
                            <span>{place.subTitle}</span>
                            <span>{place.date}</span>
                        </div>
                    </div>
                  </div>
                <p>{place.description}</p>
              </div>
              
            </div>
           ))}
           </div>
           <div className="secondary-button">
                <a href="https://stephjeter.com/documents/Stephanie_Jeter_Resume.pdf" className="btn btn-primary" target="_blank" rel="noreferrer">View Full Resume <i className="fa-solid fa-download"></i></a>
            </div>
            </div>
        </section>
        );
}
        

        export default WorkPlaces;